<template>

  <div class="padded">
    <div v-if="rowData.sharers > 0">
      <h2>{{utilLabel}} {{rowData.period}} Details for {{rowData.siteName}}</h2>
        <utility-sharing-table :row-data="rowData" :site-id="rowData.site_id" />
      </div>
    <div v-else>
      <center><h3>No sharers found</h3></center>
    </div>

  </div>
</template>

<script>

import UtilitySharingTable from '@/components/utility/UtilitySharingTable'

export default {
  components: {
    UtilitySharingTable
  },

  props: {
    rowData: Object
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(this.rowData)
    }
  },

  mounted () {
//    console.log('Util Report Details: ', this.rowData)
  }

}
</script>



// WEBPACK FOOTER //
// UtilityReportDetails.vue?eec0c9b4